import { DashboardRoutes } from "@/router";
import { Outlet, useLocation } from "react-router-dom";
import NavigationLayout from "@/components/NavigationLayout";
import { DetectMobileView } from "@/router/DetectMobileView";
import { dashboardRoutesArray } from "@/router/constant";
import MyShopMenu from "@/components/DashShop/Menu";
import { useMemo } from "react";

const MobileMyShopWrapper = () => {
  const location = useLocation();
  const memoDashboardRoutesArray = useMemo(() => dashboardRoutesArray(), []);
  const currentUrlObj = memoDashboardRoutesArray.find((i) => i.url === location.pathname);

  const mainMenu = <MyShopMenu />;

  const subMenus = (
    <NavigationLayout
      menu={mainMenu}
      mobileBackNavigation={DashboardRoutes.myShop.root.url}
      mobileTitle={currentUrlObj?.meta?.translation || ""}
    >
      <Outlet />
    </NavigationLayout>
  );

  return location.pathname === DashboardRoutes.myShop.root.url ? mainMenu : subMenus;
};

const DesktopMyShopWrapper = () => (
  <NavigationLayout menu={<MyShopMenu />}>
    <Outlet />
  </NavigationLayout>
);

const MyShopRoot = () => <DetectMobileView mobile={<MobileMyShopWrapper />} desktop={<DesktopMyShopWrapper />} />;

export default MyShopRoot;
